import { DataSource, Layout, Table} from "@mcleod/components";

export abstract class AutogenLayoutTableCustomerOrders extends Layout {
	sourceOrders: DataSource;
	tableOrders: Table;
}
